<template>
  <v-card
    flat
    class="pa-3"
    :class="{'mx-3':$vuetify.breakpoint.mdAndUp}"
    :width="$vuetify.breakpoint.mdAndDown ? '418px':'auto'"
  >
    <v-layout column style="width: 100%">

<!--      <v-flex class="text-left">{{ item.created_at | moment("DD.MM.YYYY")}}</v-flex>-->
      <v-flex class="mb-4">
        <a @click="openLink(onclick)">
          <img style="width: 100%; max-width: 408px; max-height: 408px; min-height: auto" :src="imgname"  />
        </a>
      </v-flex>
      <v-flex class="text-left hover-opacity txt-ellipsis" style="color: #FF5100;font-weight: bold;height: auto">
        <span style="cursor: pointer" @click="openLink(onclick)">Creative Industry Database: {{item.category_name}}</span>
      </v-flex>
      <v-flex class="text-left txt-ellipsis mb-5">{{ desc }}</v-flex>
      <v-row>
        <v-col xl="7" lg="7" md="7" sm="7" cols="7" >
          <v-flex class="text-left">
<!--          <router-link class="nav-link" :to="`/article/detail/`+item.article_id">-->
          <router-link class="nav-link" :to="`/`">
            <v-btn @click="openLink" small fab depressed class="white--text mr-3 morebtn-hover" color="#FF5100">
              <v-icon>add</v-icon>
            </v-btn>
          </router-link>
<!--          <router-link class="nav-link" :to="`/article/detail/`+item.article_id">-->
          <router-link class="nav-link" :to="`/`">
            <span @click="openLink" style="user-select: none;cursor: pointer">{{$t('readMore')}}</span>
          </router-link>
        </v-flex>
        </v-col>
        <v-col xl="5" lg="5" md="5" sm="5" cols="5" class="pt-5">
          <v-flex class="text-right">
            {{ item.article_date | moment("DD.MM.YYYY")}}
          </v-flex>
        </v-col>
      </v-row>


    </v-layout>
  </v-card>
</template>

<script>
import {domain} from "@/services/Constants";

export default {
  name: "ReportCard",
  props: ["id", "item", "title", "date", "imgname", "desc", "onclick"],
  mounted() {
    // console.log(this.item);
  },
  methods: {
    openLink() {
      //window.open(``);
      // console.log("this.item.article_id",this.item.article_id);
      if (this.$route.path != '/article/detail/'+this.item.article_id){
        this.$router.push({
          name: "articleDetail",
          params: { id: this.item.article_id }
        });
        location.reload()

      }else {
        location.reload()
      }

    }
  }
};
</script>

<style scoped>
.imgBox img {
  max-width: 376px;
  max-height: 320px;
}

.imgBox {
  height: 376px;
  border: 1px solid grey;
  align-items: center;
  display: flex;
  justify-content: center;
}

.hover-opacity:hover {
  opacity: 0.75;
}

.morebtn-hover:hover {
  -webkit-animation: spin 0.4s linear;
}
.morebtn-hover {
  -webkit-animation: revertspin 0.4s linear;
}

.txt-ellipsis {
  height: 75px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  display: block;
  display: -webkit-box;
}

@-webkit-keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
}
@-webkit-keyframes revertspin {
  from {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(0deg);
  }
}
</style>
